import { SearchPage } from './component'

export default SearchPage
